const mzName = 'media-zoom';
const slideName = `${mzName  }__slide`;
const slideZoomedClass = `${slideName  }--zoomed`;
let zoomTarget;
let zoomTargetPicture;
let zoomTargetImg;
let startDistance = 0;
const moveCoord = {};
let dblTapTimeout;
const dblTapThreshold = 500;
let lastTap = dblTapThreshold + 1;
let lastTapCoord = { x: 0, y: 0 };
const smScreenOrigSize = 550;
//"small" original size
const smScreenZoomSize = 1000;
//"small" zoomed size
const mdScreenOrigSize = 700;
//"medium" original size
const mdScreenZoomSize = 1200;

const naturalImgWidth = () => cube.ui.isMobile() ? smScreenOrigSize : mdScreenOrigSize;

const largeImgWidth = () => cube.ui.isMobile() ? smScreenZoomSize : mdScreenZoomSize;

// return true if the event target is a zoom slide (or a child of it)
const isAZoomedSlide = (event, slide) => event.target.classList.contains(slideZoomedClass) || isAZoomedSlideChild(slide, event.target);

function getFingerDistance(coord) {
  const { x1, y1, x2, y2 } = coord;
  const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

  return Math.round(distance);
}

function isAZoomedSlideChild(slide, child) {
  let node = child.parentNode;

  while (node !== null) {
    if (node === cube.$(`.${slideZoomedClass}`)) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

function updatePictureSources(pictureTag) {
  const strippedSrc = pictureTag.$('.source-small').srcset.replace(/f=\d*x\d*/g, '');
  //empty the dimension parameter to have the *root URL* of the PIXL image
  const sourceSmall = pictureTag.$('.source-small');
  const sourceMedium = pictureTag.$('.source-medium');
  let smallImgWidth = smScreenZoomSize;
  const mediumImgWidth = mdScreenZoomSize;


  if (zoomTarget.classList.contains(slideZoomedClass)) {
    smallImgWidth = smScreenOrigSize;
  }

  sourceSmall.srcset = `${strippedSrc}f=${smallImgWidth}x${smallImgWidth}`;
  sourceMedium.srcset = `${strippedSrc}f=${mediumImgWidth}x${mediumImgWidth}`;
}

function scrollToMiddle() {
  const leftScrollVal = (zoomTarget.scrollWidth - zoomTarget.offsetWidth) / 2;
  const topScrollVal = (zoomTarget.scrollHeight - zoomTarget.offsetHeight) / 2;

  zoomTarget.scrollLeft = leftScrollVal;
  zoomTarget.scrollTop = topScrollVal;
}

function animateScrollToMiddle(targetWidth) {
  scrollToMiddle();
  if (parseInt(zoomTargetImg.width, 10) !== targetWidth) {
    window.requestAnimationFrame(() => {
      animateScrollToMiddle(targetWidth);
    });
  } else {
    zoomTargetImg.style.removeProperty('width');
    zoomTargetImg.style.removeProperty('max-width');
  }
}

function zoomPicture(zoomDirection) {
  const smallWidthToApply = Math.min(naturalImgWidth(), zoomTarget.offsetWidth);
  const targetWidth = (zoomDirection === 'out') ? smallWidthToApply : largeImgWidth();

  if (zoomDirection === 'out')
    zoomTargetImg.style.maxWidth = 'none';

  zoomTargetImg.style.width = `${smallWidthToApply  }px`;
  updatePictureSources(zoomTargetPicture);

  if (zoomDirection === 'out')
    zoomTarget.classList.remove(slideZoomedClass);
  else
    zoomTarget.classList.add(slideZoomedClass);

  if (zoomDirection === 'in')
    zoomTargetImg.style.width = `${largeImgWidth()}px`;

  window.requestAnimationFrame(() => {
    animateScrollToMiddle(targetWidth);
  });
}

function toggleZoomPicture() {
  const zoomDirection = (zoomTarget.classList.contains(slideZoomedClass)) ? 'out' : 'in';
  zoomPicture(zoomDirection);
}

function isZoomable(zoomDirection) {
  const isZoomed = zoomTarget.classList.contains(slideZoomedClass);
  return ((zoomDirection === 'in') && !isZoomed) || ((zoomDirection === 'out') && isZoomed);
}

function touchEnd(event) {
  const endDistance = getFingerDistance(moveCoord);
  let zoomDirection;

  zoomTarget.removeEventListener('touchmove', touchMove);

  // only act touch end when there's no more finger on the screen
  if (event.touches.length === 0) {

    //cancel events
    zoomTarget.removeEventListener('touchend', touchEnd);

    zoomDirection = (startDistance < endDistance) ? 'in' : 'out';
    if (isZoomable(zoomDirection))
      zoomPicture(zoomDirection);

    // rebind touchstart
    zoomTarget.addEventListener('touchstart', touchStart);
  }
}

function touchMove(event) {
  event.preventDefault();
  moveCoord.x1 = event.touches[0].clientX;
  moveCoord.y1 = event.touches[0].clientY;
  moveCoord.x2 = event.touches[1].clientX;
  moveCoord.y2 = event.touches[1].clientY;
}

function listenDoubleTap(event) {
  const currentTime = new Date().getTime();
  const timeDiff = currentTime - lastTap;
  const newTapCoord = { x: event.x, y: event.y };
  const tapDistance = getFingerDistance({
    x1: lastTapCoord.x,
    y1: lastTapCoord.y,
    x2: newTapCoord.x,
    y2: newTapCoord.y
  });

  zoomTarget.removeEventListener('mousedown', listenDoubleTap);
  event.preventDefault();

  clearTimeout(dblTapTimeout);

  if (timeDiff < dblTapThreshold && timeDiff > 10 && tapDistance < 50) {
    // Double Tap
    toggleZoomPicture();
    lastTap = currentTime - dblTapThreshold;
  } else {
    // Single Tap
    dblTapTimeout = setTimeout(() => {
      clearTimeout(dblTapTimeout);
    }, dblTapThreshold);
    lastTap = currentTime;
  }

  lastTapCoord = newTapCoord;
}

function touchStart(event) {
  const touchesNumber = (event.touches) ? event.touches.length : 1;

  zoomTarget = event.target.closest(`.${  slideName}`);
  zoomTargetPicture = zoomTarget.$('picture');
  zoomTargetImg = zoomTarget.$('img');

  if (isAZoomedSlide(event, zoomTarget)) {
    event.stopPropagation();
  }

  if (touchesNumber > 1) {
    const touch1x = event.touches[0].clientX;
    const touch1y = event.touches[0].clientY;
    const touch2x = event.touches[1].clientX;
    const touch2y = event.touches[1].clientY;

    event.preventDefault();
    zoomTarget.removeEventListener('touchstart', touchStart);
    zoomTarget.removeEventListener('mousedown', listenDoubleTap);

    // Log initial finger position & listen pinch
    startDistance = getFingerDistance({ x1: touch1x, y1: touch1y, x2: touch2x, y2: touch2y });
    zoomTarget.addEventListener('touchend', touchEnd);
    zoomTarget.addEventListener('touchmove', touchMove);
  } else {
    zoomTarget.addEventListener('mousedown', listenDoubleTap);
  }
}

export function init() {
  const slider = cube.$id(`${mzName  }__slider`);
  const slides = slider.$$(`.${  slideName  }:not(.${  slideName  }--video):not(.fw-slider__clone)`);

  slides.forEach(sl => {
    sl.addEventListener('touchstart', touchStart);
    sl.addEventListener('mousedown', e => e.preventDefault());
  });
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/image-zoom.js